import { translate } from '../../../common/helpers/translate.helper';
import { Characters } from '../../../common/helpers/unicode.helper';
import { Text } from '../../Text/Text';

interface OptionalProps {
    disabled?: boolean;
}

export const Optional = ({ disabled }: OptionalProps) => {
    return (
        <Text variant="small" color={disabled ? 'foreground.disabled' : 'foreground.muted'}>
            {Characters.NO_BREAK_SPACE}
            {translate('global.optionalLabel')}
        </Text>
    );
};
